import { shape, string } from 'prop-types'

const enumIdType = shape({
  id: string,
  name: string,
})

export default enumIdType
